import React from 'react';
import { Modal, Box, Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import styles from './DeleteConfirmationModal.module.css';
import { ConfirmationButton } from '../Buttons/Buttons';

export default function DeleteConfirmationModal({
  title,
  body,
  open,
  onClose,
  onConfirm,
  children,
}) {
  return (
    <Modal open={open} onClose={onClose} className={styles.modal}>
      <Box
        bgcolor="background.paper"
        boxShadow={3}
        borderRadius="12px"
        p={2}
        className={styles.modalBody}
      >
        <div>
          <IconButton aria-label="delete" size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </div>

        <Divider className={styles.mt10} />
        <div className={styles.modalTextContainer}>
          <div className={styles.modalTitle}>{title}</div>
          <div className={styles.modalText}>{body}</div>
          {children}
        </div>
        <Divider className={styles.mt10} />

        <div className={styles.buttonContainer}>
          <ConfirmationButton destructive onClick={onConfirm}>
            Yes, Delete
          </ConfirmationButton>
          <ConfirmationButton onClick={onClose}>No, Cancel</ConfirmationButton>
        </div>
      </Box>
    </Modal>
  );
}

DeleteConfirmationModal.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  children: PropTypes.node,
};
